module.exports = __webpack_public_path__ + "assets/img/email-7eba9ef9.png";